import React from "react";
import { useGlobalContext } from "../../context";
import Loading from "../Loading";
import Paginate from "./Paginate";
import UserForm from "./UserForm";

const mapUser = (u) => ({
  id: u.id,
  fullName: u.fullName,
  username: u.username,
  password: "",
  idNumber: u.idNumber,
  entries: u.entries.map((e) => ({
    id: e.id,
    exam: e.exam?.id,
    examName: e.exam?.name,
    grade: e.grade,
    status: e.status,
    registrationDate: e.registrationDate,
    startDate: e.startDate,
  })),
});

const Users = () => {
  const { apiClient } = useGlobalContext();
  const [loading, setLoading] = React.useState(false);
  const [users, setUsers] = React.useState([]);
  const [userCount, setUserCount] = React.useState(0);
  const [exams, setExams] = React.useState([]);
  const [sort, setSort] = React.useState("username");
  const [search, setSearch] = React.useState("");
  const [page, setPage] = React.useState(1);
  const searchRef = React.useRef(null);

  async function removeUsers(id) {
    if (window.confirm("Do you really want to delete this Student?")) {
      try {
        setLoading(true);
        await apiClient.delete(`/users/${id}`);
        setUsers(users.filter((e) => e.id !== id));
      } catch (error) {
        alert(error);
      } finally {
        setLoading(false);
      }
    }
  }

  async function updateUsers(newUser) {
    newUser = mapUser(newUser);
    const i = users.findIndex((e) => e.id === newUser.id);
    if (i === -1) {
      setUsers([...users, { ...newUser, entry: {} }]);
    } else {
      const items = [...users];
      items[i] = { ...items[i], ...newUser };
      setUsers(items);
    }
  }

  async function getUsers() {
    try {
      setLoading(true);
      const res = await apiClient.get(
        `/users?_sort=${sort}&_q=${search}&_start=${(page - 1) * 10}&_limit=10`
      );
      const data = res.data;
      if (!data || data.length < 1) {
        setUsers([]);
      } else {
        setUsers(data.map(mapUser));
      }
    } catch (error) {
      console.log(error);
      alert(error);
    } finally {
      setLoading(false);
    }
  }
  async function countUser() {
    try {
      const res = await apiClient.get(`/users/count?_q=${search}`);
      setUserCount(res.data || 0);
    } catch (error) {
      alert(error);
    }
  }
  async function getExams() {
    try {
      const res = await apiClient.get("/exams");
      setExams(res.data.map((e) => ({ id: e.id, name: e.name })));
    } catch (error) {
      alert(error);
    }
  }

  React.useEffect(() => {
    setPage(1);
    countUser();
  }, [search]);
  React.useEffect(() => {
    getUsers();
    if (!exams || !exams.length) {
      getExams();
    }
  }, [sort, search, page]);

  return (
    <>
      <div className="d-flex flex-column">
        <div className="d-flex align-items-center mb-3">
          <h4 className="text-muted me-3 mb-0">Students ({userCount})</h4>
          <UserForm
            exams={exams}
            setLoading={setLoading}
            updateUsers={updateUsers}
            userData={false}
          />
          <div className="ms-auto me-2">
            <div className="input-group input-group-sm">
              <label
                htmlFor="sort-select"
                className="input-group-text border-end-0"
              >
                <small>Sort by</small>
              </label>
              <select
                name="sort-select"
                id="sort-select"
                className="form-select form-select-sm ms-auto"
                value={sort}
                onChange={(e) => setSort(e.target.value)}
              >
                <option value="username">User Name</option>
                <option value="fullName">Full Name</option>
              </select>
            </div>
          </div>
          <div>
            <div className="input-group">
              <input
                type="search"
                name="search"
                id="search-input"
                className="form-control form-control-sm"
                placeholder="Search here..."
                ref={searchRef}
                onChange={(e) => {
                  if (!e.target.value) {
                    setSearch("");
                  }
                }}
              />
              <button
                className="btn btn-sm btn-outline-primary"
                onClick={() => setSearch(searchRef.current.value)}
              >
                Search
              </button>
            </div>
          </div>
        </div>
        {loading ? (
          <Loading />
        ) : users.length === 0 ? (
          <h5 className="mb-0">No student found.</h5>
        ) : (
          users.map((u) => (
            <div
              className="d-flex align-items-center bg-light rounded p-2 my-1"
              key={u.id}
            >
              <div className="me-auto ps-2">
                <h6 className="m-0">{u.username}</h6>
                <p className="m-0 form-text">{u.fullName}</p>
              </div>
              <UserForm
                exams={exams}
                setLoading={setLoading}
                updateUsers={updateUsers}
                userData={u}
              />
              <button
                className="btn btn-sm btn-danger ms-2"
                onClick={() => removeUsers(u.id)}
              >
                Remove
              </button>
            </div>
          ))
        )}
        <Paginate total={userCount} setPage={setPage} page={page} />
      </div>
    </>
  );
};

export default Users;
